
/*eslint-disable */
import { io } from "socket.io-client";
const url = require("./client_config/config").socketUrl;

const URL = url;
const socket = io(URL, { autoConnect: false });

socket.onAny((event, ...args) => {
  console.log(event, args);
});

export default socket;
